import {NeoButton, NeoDatePicker} from "@/components/forms";
import {useNeoContext} from "@/context/neo/neo.context";
import {yupResolver} from "@hookform/resolvers/yup";
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@nextui-org/react";
import {NextPage} from "next";
import {useEffect, useState} from "react";
import {Controller, Resolver, useForm} from "react-hook-form";
import Select from "react-select";
import * as yup from "yup";
export const UserVehicleSwitcher: NextPage<any> = function ({checkedRows}) {
  const [isOpen, setIsOpen] = useState(false);
  const validationSchema = yup.object().shape({
    date: yup
      .object({
        from: yup.date().required("Please select a From Date"),
        to: yup.date().required("Please select a To Date")
      })
      .required(),
    trackerId: yup.string().required("Vehicle is required")
    //  to: yup.date().required("Please Enter To Date")
  });
  const {vehicles} = useNeoContext();
  const {
    control,
    setValue,
    register,
    handleSubmit,
    setError,
    formState: {isSubmitting, isValid, errors}
  } = useForm<any>({
    mode: "onChange",
    resolver: yupResolver(validationSchema) as Resolver<any>
  });

  useEffect(() => {
    const currentDate = new Date();
    const fromDate = new Date(currentDate);
    const toDate = new Date(currentDate);
    toDate.setHours(23, 59, 59, 999);
    toDate.setDate(toDate.getDate() + 6); // Next 7 days = today + next 6
    fromDate.setHours(0, 0, 0, 0);
    const selectedDateRange = {
      from: fromDate,
      to: toDate
    };
    setValue("date", selectedDateRange);

    //setIsOpen(true);
  }, []);
  const onDateChange = (event: any) => {
    // setSelectedDateRange(event);
    setValue("date", event);
  };
  const onSubmit = async (data: any) => {
    //console.log("Submitted Data: ", data);
    const trackerId = data.trackerId;
    const fromDate = data.from;
    const toDate = data.to;
    if (!fromDate || !toDate) {
      setError("date", {
        type: "manual",
        message: "From to date is required"
      });
      return;
    }
  };
  return (
    <>
      <Popover
        placement="bottom"
        className="cursor-pointer"
        isOpen={isOpen}
        //onOpenChange={open => setIsOpen(open)}
        //triggerType={"menu"}
        isDismissable={false}
        isKeyboardDismissDisabled={true}
        shouldCloseOnInteractOutside={() => false}
        showArrow={true}
        backdrop={"opaque"}
      >
        <PopoverTrigger>
          <Button
            size="sm"
            onClick={() => {
              //console.log("Button clicked");
              setIsOpen(prev => !prev);
            }}
            disabled={checkedRows.length === 0}
            className={
              checkedRows.length === 0
                ? "cursor-not-allowed bg-gray-300 text-gray-500"
                : "bg-gray-200 text-black hover:bg-gray-300"
            }
            title="Select at least one student before changing the vehicle."
          >
            {/* Switch Vehicle */}
            <div className="mr-2 inline-flex items-center gap-4">
              <svg
                width="20"
                height="20"
                viewBox="0 0 91 53"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-black"
              >
                <path
                  d="M36.1092 30.9409C31.953 35.0971 26.4295 37.3862 20.5542 37.3862H15.023V28.3589L0 40.3859L15.023 52.4129V43.3856H20.5542C28.0347 43.3856 35.0662 40.4715 40.3552 35.1864L42.4099 33.1317L38.1677 28.8895L36.113 30.9442L36.1092 30.9409Z"
                  fill="currentColor"
                />
                <path
                  d="M54.0624 21.473C58.2186 17.3168 63.7421 15.0277 69.6174 15.0277H75.4455V24.055L90.4685 12.028L75.4455 0.000976562V9.02828H69.6174C62.1369 9.02828 55.1054 11.9424 49.8164 17.2275L48.0586 18.9853L52.3008 23.2275L54.0586 21.4697L54.0624 21.473Z"
                  fill="currentColor"
                />
                <path
                  d="M75.4493 37.3828H69.9181C64.0431 37.3828 58.5201 35.0937 54.3631 30.9375L40.6521 17.2265C35.363 11.9374 28.3321 9.0273 20.8511 9.0273H15.023V0L0 12.027L15.023 24.054V15.0267H20.8511C26.7261 15.0267 32.2531 17.3158 36.4061 21.472L50.1171 35.183C55.4062 40.4721 62.4371 43.3822 69.9181 43.3822H75.4493V52.4095L90.4723 40.3825L75.4493 28.3555V37.3828Z"
                  fill="currentColor"
                />
              </svg>
              Switch Vehicle
            </div>
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full space-y-3  px-5 py-3"
          >
            <div className="flex flex-col gap-1">
              <label
                // style={style.label}
                id="aria-label"
                htmlFor="aria-example-input"
              >
                Vehicle
              </label>
              <Select
                name="trackerId"
                // {...field}
                options={vehicles}
                // defaultValue={vehicles.find(
                //   opt => opt.value === selectedOption?.value
                // )}
                //  menuPosition="fixed"
                getOptionLabel={e => e.trackerName}
                getOptionValue={e => e.trackerId.toString()}
                //value={field.value}
                onChange={selectedOption => {
                  setValue("trackerId", selectedOption?.trackerId);
                }}
                // onChange={selectedOption => field.onChange(selectedOption)}
                placeholder="Select Vehicle"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "40px",
                    borderWidth: "2px",
                    borderColor: "#d4d4d8",
                    borderRadius: "12px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    boxShadow: "none",
                    fontSize: "14px",
                    color: "#111827",
                    backgroundColor: "white",
                    "&:hover": {
                      borderColor: "#d4d4d8"
                    }
                  }),

                  placeholder: base => ({
                    ...base,
                    color: "#6b7280",
                    fontSize: "14px"
                  }),
                  indicatorSeparator: () => ({
                    display: "none"
                  }),
                  dropdownIndicator: base => ({
                    ...base,
                    color: "#6b7280",
                    paddingRight: "8px"
                  }),
                  // singleValue: base => ({
                  //   ...base,
                  //   color: "#111827"
                  // }),
                  menu: base => ({
                    ...base,
                    borderRadius: "10px",
                    zIndex: 50
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused ? "#e5e7eb" : "white",
                    color: "#111827",
                    padding: "10px 12px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    margin: "2px 4px"
                  })
                }}
              />
              {errors.trackerId &&
                typeof errors.trackerId === "object" &&
                "message" in errors.trackerId &&
                typeof errors.trackerId.message === "string" && (
                  <p className="mt-1 text-sm text-red-500">
                    {errors.trackerId.message}
                  </p>
                )}
            </div>
            <Controller
              name="date"
              control={control}
              render={({field}) => (
                <NeoDatePicker
                  type={"range"}
                  label="Date Range"
                  allowFuture={true}
                  handleDateChange={value => field.onChange(value)}
                  rangedefaultValue={field.value}
                />
              )}
            />
            <div className="flex justify-center">
              <NeoButton
                className="mx-5 mt-2"
                size="sm"
                type="submit"
                disabled={isSubmitting}
                // isLoading={loading}
                // spinner={
                //   <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
                // }
                color="black"
              >
                Save
              </NeoButton>
              <NeoButton
                className="mx-5 mt-2"
                size="sm"
                type="button"
                color="red"
                onPress={() => {
                  setIsOpen(false);
                }}
              >
                Cancel
              </NeoButton>
            </div>
          </form>
        </PopoverContent>
      </Popover>
    </>
  );
};
